// Formato de importes en euros, consistente en toda la app (es-ES, "5,00 €").
// Antes había concatenaciones manuales tipo `${amount}EUR` que producían
// "5.00EUR" en vez de "5,00 €". Usamos Intl.NumberFormat para evitarlo.
//
// OJO con las unidades: en la base de datos y en las respuestas del backend
// los importes casi siempre viajan en CÉNTIMOS (enteros). Por eso hay dos
// funciones separadas y con nombres explícitos — pasar euros a formatCents
// (o céntimos a formatEuros) multiplicaría/dividiría por 100 de más y
// mostraría cifras como "500,00 €" en vez de "5,00 €".

const currencyFormatter = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
});

// Recibe un importe YA en euros (p.ej. 5, 5.5, "5.00").
export const formatEuros = (amountInEuros) => {
  const n = Number(amountInEuros);
  return currencyFormatter.format(Number.isFinite(n) ? n : 0);
};

// Recibe un importe en CÉNTIMOS (p.ej. 500 → "5,00 €"), que es como se
// guardan y devuelven los importes de pago en este proyecto (amountCents,
// totalAmountCents, etc.).
export const formatCents = (amountInCents) => {
  const n = Number(amountInCents);
  return currencyFormatter.format(Number.isFinite(n) ? n / 100 : 0);
};
